export default [
  {
    permission: "View",
    type: "User",
  },
  {
    permission: "Create",
    type: "User",
  },
  {
    permission: "Edit",
    type: "User",
  },
  {
    permission: "Delete",
    type: "User",
  },

  {
    permission: "View",
    type: "BankClassification",
  },
  {
    permission: "Create",
    type: "BankClassification",
  },
  {
    permission: "Edit",
    type: "BankClassification",
  },
  {
    permission: "Delete",
    type: "BankClassification",
  },

  {
    permission: "View",
    type: "AttendanceDeduction",
  },
  {
    permission: "Create",
    type: "AttendanceDeduction",
  },
  {
    permission: "Edit",
    type: "AttendanceDeduction",
  },
  {
    permission: "Delete",
    type: "AttendanceDeduction",
  },

  {
    permission: "View",
    type: "UserGroup",
  },
  {
    permission: "Create",
    type: "UserGroup",
  },
  {
    permission: "Edit",
    type: "UserGroup",
  },
  {
    permission: "Delete",
    type: "UserGroup",
  },
  {
    permission: "View",
    type: "Settings",
  },
  {
    permission: "Edit",
    type: "Settings",
  },
  {
    permission: "View",
    type: "Activity",
  },
  {
    permission: "View",
    type: "Device",
  },
  {
    permission: "Create",
    type: "Device",
  },
  {
    permission: "Edit",
    type: "Device",
  },
  {
    permission: "Delete",
    type: "Device",
  },
  {
    permission: "View",
    type: "Excuse",
  },
  {
    permission: "Create",
    type: "Excuse",
  },
  {
    permission: "Edit",
    type: "Excuse",
  },
  {
    permission: "Delete",
    type: "Excuse",
  },
  {
    permission: "View",
    type: "Holiday",
  },
  {
    permission: "Create",
    type: "Holiday",
  },
  {
    permission: "Edit",
    type: "Holiday",
  },
  {
    permission: "Delete",
    type: "Holiday",
  },
  {
    permission: "View",
    type: "Nationality",
  },
  {
    permission: "Create",
    type: "Nationality",
  },
  {
    permission: "Edit",
    type: "Nationality",
  },
  {
    permission: "Delete",
    type: "Nationality",
  },
  {
    permission: "View",
    type: "WorkPlaces",
  },
  {
    permission: "Create",
    type: "WorkPlaces",
  },
  {
    permission: "Edit",
    type: "WorkPlaces",
  },
  {
    permission: "Delete",
    type: "WorkPlaces",
  },
  {
    permission: "View",
    type: "Vacation",
  },
  {
    permission: "Create",
    type: "Vacation",
  },
  {
    permission: "Edit",
    type: "Vacation",
  },
  {
    permission: "Delete",
    type: "Vacation",
  },
  {
    permission: "View",
    type: "VacationType",
  },
  {
    permission: "Create",
    type: "VacationType",
  },
  {
    permission: "Edit",
    type: "VacationType",
  },
  {
    permission: "Delete",
    type: "VacationType",
  },
  {
    permission: "View",
    type: "Shift",
  },
  {
    permission: "Create",
    type: "Shift",
  },
  {
    permission: "Edit",
    type: "Shift",
  },
  {
    permission: "Delete",
    type: "Shift",
  },
  {
    permission: "View",
    type: "Timesheet",
  },
  {
    permission: "Edit",
    type: "Timesheet",
  },
  {
    permission: "Delete",
    type: "Timesheet",
  },
  {
    permission: "Create",
    type: "Timesheet",
  },
  {
    permission: "Confirm",
    type: "Timesheet",
  },
  {
    permission: "UnConfirm",
    type: "Timesheet",
  },
  {
    permission: "AttendanceByMobileApp",
    type: "Timesheet",
  },
  {
    permission: "View",
    type: "DsektopAppVacationRequest",
  },
  {
    permission: "UnConfirm",
    type: "DsektopAppVacationRequest",
  },
  {
    permission: "Discount",
    type: "DsektopAppVacationRequest",
  },
  {
    permission: "UnDiscount",
    type: "DsektopAppVacationRequest",
  },
  {
    permission: "View",
    type: "EndService",
  },
  {
    permission: "Create",
    type: "EndService",
  },
  {
    permission: "Edit",
    type: "EndService",
  },
  {
    permission: "Delete",
    type: "EndService",
  },
  {
    permission: "View",
    type: "SituationSettlement",
  },
  {
    permission: "Create",
    type: "SituationSettlement",
  },
  {
    permission: "Delete",
    type: "SituationSettlement",
  },
  {
    permission: "View",
    type: "Deduction",
  },
  {
    permission: "Create",
    type: "Deduction",
  },
  {
    permission: "Edit",
    type: "Deduction",
  },
  {
    permission: "Delete",
    type: "Deduction",
  },

  {
    permission: "Confirm",
    type: "Deduction",
  },

  {
    permission: "UnConfirm",
    type: "Deduction",
  },

  {
    permission: "View",
    type: "Reward",
  },
  {
    permission: "Create",
    type: "Reward",
  },
  {
    permission: "Edit",
    type: "Reward",
  },
  {
    permission: "Delete",
    type: "Reward",
  },

  {
    permission: "Confirm",
    type: "Reward",
  },

  {
    permission: "UnConfirm",
    type: "Reward",
  },

  {
    permission: "View",
    type: "Bank",
  },
  {
    permission: "Create",
    type: "Bank",
  },
  {
    permission: "Edit",
    type: "Bank",
  },
  {
    permission: "Delete",
    type: "Bank",
  },
  {
    permission: "View",
    type: "EmployeeBonus",
  },
  {
    permission: "Create",
    type: "EmployeeBonus",
  },
  {
    permission: "Edit",
    type: "EmployeeBonus",
  },
  {
    permission: "Delete",
    type: "EmployeeBonus",
  },
  {
    permission: "View",
    type: "TypesBonuse",
  },
  {
    permission: "Create",
    type: "TypesBonuse",
  },
  {
    permission: "Edit",
    type: "TypesBonuse",
  },
  {
    permission: "Delete",
    type: "TypesBonuse",
  },
  {
    permission: "View",
    type: "Court",
  },
  {
    permission: "Create",
    type: "Court",
  },
  {
    permission: "Edit",
    type: "Court",
  },
  {
    permission: "Delete",
    type: "Court",
  },
  {
    permission: "View",
    type: "BankBranch",
  },
  {
    permission: "Create",
    type: "BankBranch",
  },
  {
    permission: "Edit",
    type: "BankBranch",
  },
  {
    permission: "Delete",
    type: "BankBranch",
  },
  {
    permission: "View",
    type: "EvaluationType",
  },
  {
    permission: "Create",
    type: "EvaluationType",
  },
  {
    permission: "Edit",
    type: "EvaluationType",
  },
  {
    permission: "Delete",
    type: "EvaluationType",
  },
  {
    permission: "View",
    type: "Committee",
  },
  {
    permission: "Create",
    type: "Committee",
  },
  {
    permission: "Edit",
    type: "Committee",
  },
  {
    permission: "Delete",
    type: "Committee",
  },
  {
    permission: "Confirm",
    type: "Committee",
  },
  {
    permission: "Unconfirm",
    type: "Committee",
  },

  {
    permission: "View",
    type: "OverTime",
  },
  {
    permission: "Create",
    type: "OverTime",
  },
  {
    permission: "Edit",
    type: "OverTime",
  },
  {
    permission: "Delete",
    type: "OverTime",
  },

  {
    permission: "Confirm",
    type: "OverTime",
  },

  {
    permission: "View",
    type: "FinancialDegreesEmployee",
  },
  {
    permission: "Create",
    type: "FinancialDegreesEmployee",
  },
  {
    permission: "Edit",
    type: "FinancialDegreesEmployee",
  },
  {
    permission: "Delete",
    type: "FinancialDegreesEmployee",
  },
  {
    permission: "View",
    type: "SalaryScale",
  },
  {
    permission: "UnConfirm",
    type: "Salary",
  },
  {
    permission: "Create",
    type: "SalaryScale",
  },
  {
    permission: "Edit",
    type: "SalaryScale",
  },
  {
    permission: "View",
    type: "Employee",
  },
  {
    permission: "Create",
    type: "Employee",
  },
  {
    permission: "Edit",
    type: "Employee",
  },
  {
    permission: "Upgrade",
    type: "Employee",
  },
  {
    permission: "AddBonus",
    type: "Employee",
  },
  {
    permission: "Delete",
    type: "Employee",
  },

  {
    permission: "JobInfo",
    type: "Employee",
  },

  {
    permission: "FinancialInfo",
    type: "Employee",
  },

  {
    permission: "Qualification",
    type: "Employee",
  },

  {
    permission: "VacationRecord",
    type: "Employee",
  },
  // {
  //   permission: "Delegation",
  //   type: "Employee"
  // },

  {
    permission: "JobStatus",
    type: "Employee",
  },

  {
    permission: "EmployeeDocument",
    type: "Employee",
  },
  {
    permission: "View",
    type: "EmployeePromotion",
  },
  {
    permission: "Create",
    type: "EmployeePromotion",
  },
  {
    permission: "Edit",
    type: "EmployeePromotion",
  },
  {
    permission: "Delete",
    type: "EmployeePromotion",
  },
  {
    permission: "View",
    type: "EmployeeVariable",
  },
  {
    permission: "Delete",
    type: "EmployeeVariable",
  },
  {
    permission: "Create",
    type: "EmployeeVariable",
  },
  {
    permission: "Edit",
    type: "EmployeeVariable",
  },
  {
    permission: "View",
    type: "SalaryDifferences",
  },
  {
    permission: "Confirm",
    type: "SalaryDifferences",
  },
  {
    permission: "Delete",
    type: "SalaryDifferences",
  },
  {
    permission: "Create",
    type: "SalaryDifferences",
  },
  {
    permission: "Edit",
    type: "SalaryDifferences",
  },
  {
    permission: "View",
    type: "ExcuseRequest",
  },
  {
    permission: "Create",
    type: "ExcuseRequest",
  },
  {
    permission: "Edit",
    type: "ExcuseRequest",
  },
  {
    permission: "Delete",
    type: "ExcuseRequest",
  },
  {
    permission: "View",
    type: "VacationRequest",
  },
  {
    permission: "UnConfirm",
    type: "VacationRequest",
  },
  {
    permission: "Create",
    type: "VacationRequest",
  },
  {
    permission: "Edit",
    type: "VacationRequest",
  },
  {
    permission: "Delete",
    type: "VacationRequest",
  },
  {
    permission: "Confirm",
    type: "ExcuseRequest",
  },
  {
    permission: "Unconfirm",
    type: "ExcuseRequest",
  },
  {
    permission: "Confirm",
    type: "VacationRequest",
  },
  {
    permission: "Unconfirm",
    type: "VacationRequest",
  },
  {
    permission: "View",
    type: "Department",
  },
  {
    permission: "Create",
    type: "Department",
  },
  {
    permission: "Edit",
    type: "Department",
  },
  {
    permission: "Delete",
    type: "Department",
  },

  // {
  //    permission: "Create",
  //   type: "DeparmentClassificationGroups"
  // },

  {
    permission: "View",
    type: "JobTitle",
  },
  {
    permission: "Create",
    type: "JobTitle",
  },
  {
    permission: "Edit",
    type: "JobTitle",
  },
  {
    permission: "Delete",
    type: "JobTitle",
  },
  {
    permission: "View",
    type: "Salary",
  },
  {
    permission: "Create",
    type: "Salary",
  },
  {
    permission: "Edit",
    type: "Salary",
  },
  {
    permission: "Delete",
    type: "Salary",
  },
  {
    permission: "Calculate",
    type: "Salary",
  },
  {
    permission: "Closed",
    type: "Salary",
  },
  {
    permission: "Release",
    type: "Salary",
  },
  {
    permission: "ClosedMounth",
    type: "Salary",
  },
  {
    permission: "Calculated",
    type: "Salary",
  },
  {
    permission: "View",
    type: "SalariesSelfService",
  },
  {
    permission: "View",
    type: "SalaryReports",
  },
  {
    permission: "Create",
    type: "SalaryReports",
  },
  {
    permission: "Edit",
    type: "SalaryReports",
  },

  {
    permission: "Delete",
    type: "SalaryReports",
  },
  {
    permission: "View",
    type: "DocumentType",
  },
  {
    permission: "Create",
    type: "DocumentType",
  },
  {
    permission: "Edit",
    type: "DocumentType",
  },
  {
    permission: "Delete",
    type: "DocumentType",
  },
  {
    permission: "View",
    type: "Evaluation",
  },
  {
    permission: "Create",
    type: "Evaluation",
  },
  {
    permission: "Edit",
    type: "Evaluation",
  },
  {
    permission: "Delete",
    type: "Evaluation",
  },

  {
    permission: "View",
    type: "EmployeeEfficiency",
  },
  {
    permission: "Create",
    type: "EmployeeEfficiency",
  },
  {
    permission: "Edit",
    type: "EmployeeEfficiency",
  },
  {
    permission: "Delete",
    type: "EmployeeEfficiency",
  },

  {
    permission: "View",
    type: "ScientificDegree",
  },
  {
    permission: "Create",
    type: "ScientificDegree",
  },
  {
    permission: "Edit",
    type: "ScientificDegree",
  },
  {
    permission: "Delete",
    type: "ScientificDegree",
  },
  {
    permission: "View",
    type: "VacationRecord",
  },

  {
    permission: "UnConfirm",
    type: "ExcuseRequest",
  },
  {
    permission: "Confirm",
    type: "EmployeeBonus",
  },
  {
    permission: "UnConfirm",
    type: "EmployeeBonus",
  },
  {
    permission: "Create",
    type: "VacationRecord",
  },
  {
    permission: "Edit",
    type: "VacationRecord",
  },
  {
    permission: "Delete",
    type: "VacationRecord",
  },
  {
    permission: "Topup",
    type: "VacationRecord",
  },
  {
    permission: "View",
    type: "CompanyInfo",
  },
  {
    permission: "View",
    type: "DigitalStamp",
  },
  {
    permission: "Create",
    type: "DigitalStamp",
  },
  {
    permission: "Edit",
    type: "DigitalStamp",
  },
  {
    permission: "Delete",
    type: "DigitalStamp",
  },
  {
    permission: "Confirm",
    type: "DigitalStamp",
  },
  {
    permission: "UnConfirm",
    type: "DigitalStamp",
  },
  {
    permission: "ApprovalRequest",
    type: "VacationRequest",
  },
  {
    permission: "Reject",
    type: "VacationRequest",
  },
  {
    permission: "ApprovalRequest",
    type: "ExcuseRequest",
  },
  {
    permission: "Reject",
    type: "ExcuseRequest",
  },
  {
    permission: "Edit",
    type: "CompanyInfo",
  },

  {
    permission: "View",
    type: "DepartmentClassifications",
  },
  {
    permission: "Create",
    type: "DepartmentClassifications",
  },
  {
    permission: "Edit",
    type: "DepartmentClassifications",
  },
  {
    permission: "Delete",
    type: "DepartmentClassifications",
  },
];
